import { Routes, Route } from "react-router-dom";
import { WorkerPage } from "@/pages/WorkerPage";

/**
 * 근로자용 앱 라우팅.
 * - "/"       설치 앱 시작점 (저장된 현장 uuid 로)
 * - "/:uuid"  QR 진입 (현장 uuid)
 * basename 은 배포 경로(/worker)에 맞춰 main.tsx 에서 설정.
 */
export function App() {
  return (
    <Routes>
      <Route path="/" element={<WorkerPage />} />
      <Route path="/:uuid" element={<WorkerPage />} />
      <Route path="*" element={<WorkerPage />} />
    </Routes>
  );
}
